import { Height } from "@mui/icons-material";
import React from "react";

const statusItems = [
    {
        icon: "/assets/icons/check.png",
        title: "Quarry Rehabilitation",
        status: "Completed",
        date: "Apr 17, 2025",
        color: "#22c55e", // green
    },
    {
        icon: "/assets/icons/warningy.png",
        title: "Site Survey",
        status: "In Progress",
        date: "Apr 15, 2025",
        color: "#facc15", // yellow
    },
    {
        icon: "/assets/icons/multiply.png",
        title: "Bridge Inspection",
        status: "Failed",
        date: "Apr 12, 2025",
        color: "#ef4444", // red
    },
];

export default function ProjectStatusCard() {
    return (
        <div style={styles.card}>
            <h3 style={styles.title}>Project Status</h3>
            {statusItems.map((item, idx) => (
                <div key={idx} style={styles.itemRow}>
                    <div style={styles.details}>
                        <div style={{ ...styles.icon }}><img src={item.icon} alt="icon" width="100%" /></div>
                        <div style={styles.label}>{item.title}</div>
                    </div>
                    <div style={styles.details2}>
                        <div style={{ color: item.color, }}>
                            {item.status}
                        </div>
                        <div style={{ color: item.color,}}>
                            {item.date}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

const styles = {
    card: {
        color: "white",
        width: "100%",
        Height: "100%",
        fontSize:"80%"
    },
    title: {
        fontSize: "100%",
        textAlign: "start",
    },
    itemRow: {
        display: "flex",
        alignItems: "start",
        justifyContent: "space-between",
        flexDirection:"column"
    },
    icon: {
        width:"8%",
        // fontSize: "50%",
    },
    details: {
        flex: 1,
        display: "flex",
        flexDirection: "row",
        alignItems:"center",
        gap:"10px"
    },
    details2: {
        flex: 1,
        display: "flex",
        flexDirection: "row",
        alignItems:"center",
        gap:"10px",
        marginLeft:"20px"
    },
    label: {
        fontWeight: "bold",
        // fontSize: "50%",
    },
};
